module.exports = __webpack_public_path__ + "static/media/exchange.ac04b27e.png";